import who from '../../../../assets/images/who.png'
import what from '../../../../assets/images/what.png'
import why from '../../../../assets/images/why.png'

import styles from './Arg.module.css';

const Arg = props => {

	const imgPlacement = (props.index % 2 === 0 ) ? '' : 'flex-md-row-reverse';
	const imgMargin = (props.index % 2 === 0 ) ? 'me-3' : 'ms-3';
  
	let image = <img src={who} alt='We are FiscalNote' className={`${styles.Image} ${imgMargin}`} />
	if(props.img === 'what') image = <img src={what} alt='We are exploring' className={`${styles.Image} ${imgMargin}`} />
	if(props.img === 'why') image = <img src={why} alt='Now is the time to do this' className={`${styles.Image} ${imgMargin}`} />

	return (

		<div className={`px-md-4 d-md-flex align-items-center ${imgPlacement} ${styles.Argument}`}>
			<div className='d-none d-md-block'>{image}</div>
			<div className='text-center text-md-start'>
				<h3 className={styles.Title}>{props.title}</h3>
				<div className='d-md-none py-2'>{image}</div>
				<p className={styles.Body}>{props.body}</p>
			</div>
		</div>
	)

}

export default Arg;